import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { RootState } from '@/store';
import { UNUSED_DATA_RETENTION_SECONDS } from '@/utils/constants';
import { API_ENDPOINTS, API_SLICE, BASE_URL } from '@/utils/constants/apiEndpoints.ts';

import { FindAllNpiResponse, GetNPIDataQuery, NuccTaxonomy } from '@/types/npi.ts';

export const npiApiSlice = createApi({
  reducerPath: 'npiApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    }
  }),
  tagTypes: [API_SLICE.NPI],
  endpoints: (builder) => ({
    getNpiData: builder.query<FindAllNpiResponse, GetNPIDataQuery>({
      query: (params) => ({
        url: API_ENDPOINTS.NPI.GET,
        method: 'GET',
        params
      })
    }),
    getTaxonomyCodeOptions: builder.query<Array<{ label: string; value: string }>, void>({
      query: () => ({
        url: API_ENDPOINTS.NPI.TAXONOMY_CODES,
        method: 'GET'
      }),
      transformResponse(response: { taxonomyCodes: Array<NuccTaxonomy> }) {
        return (
          response?.taxonomyCodes?.map((taxonomy) => ({
            label: taxonomy.display_name,
            value: taxonomy.nucc_code
          })) ?? []
        );
      },
      keepUnusedDataFor: UNUSED_DATA_RETENTION_SECONDS
    })
  })
});

export const { useGetTaxonomyCodeOptionsQuery, useGetNpiDataQuery } = npiApiSlice;
